import { useQuery } from '@apollo/client/react'
import { GET_EMAIL_RESPONSE_STATS } from '@/lib/operations/dashboard'
import type { EmailResponseStats } from '@/lib/types'

export function useEmailResponseStats(
  clientId: string | null,
  filters?: { startDate?: string; endDate?: string }
) {
  const { data, loading, error } = useQuery<{ emailResponseStats: EmailResponseStats }>(
    GET_EMAIL_RESPONSE_STATS,
    {
      variables: { clientId, startDate: filters?.startDate, endDate: filters?.endDate },
      skip: !clientId,
    }
  )
  return { stats: data?.emailResponseStats ?? null, loading, error }
}
